export class EncodingHelper {
  public static stringToBase64(value: string): string {
    return btoa(this.stringToBinaryString(value));
    // return Buffer.from(value).toString("base64");
  }

  public static base64ToString(base64Value: string): string {
    return atob(base64Value);
    // return Buffer.from(base64Value, "base64").toString();
    // Uint8Array.fromBase64()
  }

  /** Encodes input string (UTF-8/UTF-16, ASCII/Unicode) to UTF-8 encoded bytes. */
  public static stringToUtf8Bytes(value: string): Uint8Array<ArrayBuffer> {
    const encoder = new TextEncoder();
    const utf8Bytes = encoder.encode(value);
    return utf8Bytes;
  }

  public static binaryStringToUtf8Bytes(value: string): Uint8Array<ArrayBuffer> {
    const utf8Bytes = new Uint8Array(value.length);
    for (let i = 0; i < value.length; i++) {
      utf8Bytes[i] = value.charCodeAt(i);
    }
    return utf8Bytes;
  }

  /** Encodes input string (UTF-8/UTF-16, ASCII/Unicode) to binary string (UTF-8 encoded bytes). */
  public static stringToBinaryString(value: string): string {
    const utf8Bytes = this.stringToUtf8Bytes(value);
    let binaryString = "";
    for (let i = 0; i < utf8Bytes.length; i++) {
      binaryString += String.fromCharCode(utf8Bytes[i]);
    }
    return binaryString;
  }
}
